import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { Player, ControlBar } from 'video-react';
import MediaConfirmRemoveFileModal from './media-confirm-remove-file-modal';
import videoIcon from 'assets/img/file_video.png';
import 'video-react/dist/video-react.css';
import MediaLibraryEditItemModal from './media-library-edit-item-modal';
import isEmpty from 'lodash/isEmpty';
class MediaLibraryItem extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.object,
    onRemoveVideo: PropTypes.func,
    onUpdateVideoName: PropTypes.func,
    onCancelUpload: PropTypes.func,
    onFetchCategory: PropTypes.func,
    MediaCategories: PropTypes.array,
    SelectListRegions: PropTypes.array,
    onFetchRegion: PropTypes.func,
    ProjectList: PropTypes.array,
    onFetchProject: PropTypes.func,
    onCopyProject: PropTypes.func,
    onCheckCopyProjectDuplicate: PropTypes.func,
    onCheckCopyByRegion: PropTypes.func,
    ListCheckCopiedRegion: PropTypes.array,
    onUpdateCategory: PropTypes.func,
    disableEdit: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    this.uuid = uuidv4();
    this.state = {
      isEditFileName: false,
      openModalConfirmRemoveFile: false,
      thumbnailWidth: 0,
      videoThumbnailWidth: 0,
      showDialog: false,
      player: {
        paused: true,
        videoHeight: 0,
        videoWidth: 0
      },
      openMediaEdit: false
    };
  }

  componentDidMount() {
    document.addEventListener('click', this.handleHideEmbedPreview);
    this.onSetThumbnailWrapperWidth();
    // subscribe state change
    if (this.refs.player) {
      this.refs.player.subscribeToStateChange(this.handleStateChange);
    }
  }

  componentDidUpdate() {
    this.onSetThumbnailWrapperWidth();
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleHideEmbedPreview);
  }

  onSetThumbnailWrapperWidth() {
    const nameSpanId = `doc-file-name-${this.uuid}`;

    const { fileName } = this.props.data;

    let interval = setInterval(() => {
      let nameRender = fileName;
      const thumbnailWidth = document.getElementById(this.uuid)
        ? document.getElementById(this.uuid).offsetWidth
        : 0;
      if (thumbnailWidth <= 0) {
        nameRender = '';
      }
      if (thumbnailWidth > 0) {
        if (fileName.length * 9 > thumbnailWidth * 2 - 60) {
          const newFileName = fileName.slice(0, (thumbnailWidth * 2 - 60) / 9);
          nameRender = newFileName + '...';
        }
        clearInterval(interval);
      }
      if (document.getElementById(nameSpanId)) {
        document.getElementById(nameSpanId).innerText = nameRender;
      }
    }, 50);
  }

  handleRemoveDocument = () => {
    const { loading, onCancelUpload, data } = this.props;

    if (!loading) {
      this.setState({
        openModalConfirmRemoveFile: true,
        removeMediaId: data.id
      });
    } else {
      onCancelUpload(data);
    }
  };

  onCloseConfirmRemoveFileModal = () => {
    this.setState({
      openModalConfirmRemoveFile: false,
      removeMediaId: null
    });
  };

  onCloseMediaEdit = () => {
    this.setState({
      openMediaEdit: false
    });
  }

  onRemoveFileConfirmed = () => {
    const { removeMediaId } = this.state;

    this.props.onRemoveVideo(removeMediaId);
  };

  handlePreview = () => {
    const { loading } = this.props;

    if (!loading) {
      this.refs.player.play();

      const { player } = this.state;
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

      if (this.isMobile && !isIOS && (!player || (player && !player.isFullscreen))) {
        this.refs.player.toggleFullscreen();
      }
    }
  };

  handleClosePreviewImage = () => {
    this.setState({
      show: false,
      imageUrl: null
    });
  };

  handleHideEmbedPreview = event => {
    if (
      this.embedPreview &&
      !this.embedPreview.contains(event.target) &&
      !this.viewIcon.contains(event.target)
    ) {
      this.setState({
        pdfPreviewUrl: null
      });
    }
  };

  handleStateChange = (state, prevState) => {
    if (
      state.paused !== prevState.paused ||
      state.isFullscreen !== prevState.isFullscreen
    ) {
      this.setState({ player: state }, () => {
        if (this.isMobile) {
          if (!state.isFullscreen && !prevState.paused) {
            this.refs.player.pause();
          }
        } else {
          if (!state.paused && !this.state.showDialog) {
            this.setState({ showDialog: true, player: state }, () => {
              this.onToggleBodyScroll(false);
            });
          }
        }
      });
    }
  };

  onToggleBodyScroll = allowed => {
    if (allowed) {
      //allowed === true then allow body scroll
      document
        .getElementsByTagName('BODY')[0]
        .classList.remove('body-not-scroll');
    } else {
      //allowed === false then prevent body scroll
      document.getElementsByTagName('BODY')[0].classList.add('body-not-scroll');
    }
  };

  onToggleMediaEditModal = () => {
    this.setState({
      openMediaEdit: true
    });
  }

  onCloseVideoDialog = () => {
    this.setState(
      {
        showDialog: false
      },
      () => {
        this.refs.player.pause();
        this.onToggleBodyScroll(true);
      }
    );
  };

  renderLoading = loading => {
    if (loading) {
      return <i className='fa fa-spin fa-spinner loading-icon' />;
    }

    return null;
  };

  renderFuncButton = () => {
    const { loading } = this.props;

    if (loading) {
      return (
        <i className='fa fa-trash cancel-icon func-icon' onClick={this.handleRemoveDocument} />
      );
    } else {
      return (
        <React.Fragment>
          <i className='fa fa-trash remove-icon func-icon' onClick={this.handleRemoveDocument} />
          <i className='fa fa-eye view-icon func-icon' onClick={this.handlePreview} ref={ref => { this.viewIcon = ref; }} />
        </React.Fragment>
      );
    }
  };

  renderAuthor = () => {
    const {data} = this.props;
    const createBy = data.createBy;
    const category = data.category;
    return (
      <div className='author-line'>
          Uploaded by <span className='actor'>{createBy.displayName}</span>
        {!isEmpty(category) && <div>
          Category <span className='actor'>{category.name}</span>
        </div>}
      </div>
    );
  };

  render() {
    const {
      openMediaEdit,
      openModalConfirmRemoveFile
    } = this.state;

    const { loading, data } = this.props;

    const { showDialog, player } = this.state;

    const { videoHeight, videoWidth } = player;

    const dialogClassName = showDialog
      ? 'project-video-dialog'
      : 'project-video-item-wrapper';

    const videoItemClassName = showDialog
      ? 'project-video-playing-item'
      : 'project-video-item thumbnail-wrapper-item';

    const videoRatio = videoWidth / videoHeight;

    const videoPlayingItemHeight = window.innerHeight * 0.8;

    const videoPlayingItemWidth = videoPlayingItemHeight * videoRatio;

    const videoItemLoadingStyle = {
      background: '#e6e6e6',
      border: '1px solid #d9d9d9',
      borderRadius: 2
    };

    let videoItemStyle = !showDialog
      ? { height: 150 }
      : { height: videoPlayingItemHeight, width: videoPlayingItemWidth };

    if (loading) {
      videoItemStyle = { ...videoItemStyle, ...videoItemLoadingStyle };
    }

    const disableControlBar =
      !player ||
      (!this.isMobile && !showDialog) ||
      (this.isMobile && !player.isFullscreen);

    return (
      <div className='project-document-item-wrapper manage-search col-sm-4 col-md-4 col-lg-3' ref={ref => { this.thumbnailWrapper = ref; }} id={this.uuid}>
        <div className={dialogClassName}>

          {
            showDialog && (
              <React.Fragment>
                <div className='project-video-fade' />
                <i className='fa fa-close close-video-btn' onClick={this.onCloseVideoDialog} />
              </React.Fragment>
            )
          }

          <div className={videoItemClassName} style={videoItemStyle}>
            {
              loading
                ? (
                  <img src={videoIcon} alt='s1-video-icon' className='video-icon' />
                )
                : (
                  <Player
                    ref='player'
                    fluid={false}
                    height='100%'
                    preload='metadata'
                  >
                    <source src={data.url} />
                    <ControlBar disableCompletely={disableControlBar} />
                  </Player>
                )
            }

            <div className='document-fade' />

            {this.renderAuthor()}

            {this.renderFuncButton()}

            {loading && <i className='fa fa-spin fa-spinner loading-icon' />}
          </div>
        </div>

        <div className='file-name'>
          <div className='document-name-block'>
            <span
              id={`doc-file-name-${this.uuid}`}
              style={{ fontWeight: 600 }}
            />
            {this.props.disableEdit ? <i className='fa fa-pencil subcontractor-edit-trade-btn'/> : <i className='fa fa-pencil subcontractor-edit-trade-btn' onClick={this.onToggleMediaEditModal}/>}
          </div>
        </div>

        {openMediaEdit && (
          <MediaLibraryEditItemModal
            isOpen={openMediaEdit}
            item={data}
            onClose={this.onCloseMediaEdit}
            onUpdateVideoName={this.props.onUpdateVideoName}
            onFetchCategory={this.props.onFetchCategory}
            MediaCategories={this.props.MediaCategories}
            SelectListRegions={this.props.SelectListRegions}
            onFetchRegion={this.props.onFetchRegion}
            onFetchProject={this.props.onFetchProject}
            ProjectList={this.props.ProjectList}
            onCopyProject={this.props.onCopyProject}
            onCheckCopyProjectDuplicate={this.props.onCheckCopyProjectDuplicate}
            onCheckCopyByRegion={this.props.onCheckCopyByRegion}
            ListCheckCopiedRegion={this.props.ListCheckCopiedRegion}
            onUpdateCategory={this.props.onUpdateCategory}
          />
        )}

        {openModalConfirmRemoveFile && (
          <MediaConfirmRemoveFileModal
            isOpen={openModalConfirmRemoveFile}
            item={data}
            onClose={this.onCloseConfirmRemoveFileModal}
            onRemove={this.onRemoveFileConfirmed}
          />
        )}
      </div>
    );
  }
}

export default MediaLibraryItem;



// WEBPACK FOOTER //
// ./src/MediaLibrary/Components/media-library-item.js